import { useState } from 'react'
import { FlaskConical } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useLisReviewSummary } from '@/hooks/useLisReview'
import { pendingCount, type PendingScope } from '@/lib/lisReview'
import { LisPendingBadge } from './LisPendingBadge'
import { LisReviewListDialog } from './LisReviewListDialog'

/**
 * "LIS results" with the orange pending count, opening the review list for the
 * scope. Renders nothing while the queue is empty for it, so a tenant that gets
 * no LIS traffic never sees the control.
 */
export function LisReviewButton({
  scope,
  onDecided,
  currentSubmissionId,
}: {
  scope?: PendingScope
  onDecided?: (outcome: 'approved' | 'rejected') => void
  /** The form open on the page, so the review does not link to itself. */
  currentSubmissionId?: string | null
}) {
  const [open, setOpen] = useState(false)
  const { data } = useLisReviewSummary()
  if (pendingCount(data, scope) === 0) return null
  return (
    <>
      <Button variant='outline' size='sm' onClick={() => setOpen(true)}>
        <FlaskConical className='mr-1.5 h-3.5 w-3.5' />
        LIS results
        <LisPendingBadge scope={scope} className='ml-1.5' />
      </Button>
      <LisReviewListDialog
        open={open}
        onOpenChange={setOpen}
        scope={{
          ...(scope?.procedureId ? { procedureId: scope.procedureId } : {}),
          ...(scope?.submissionId ? { submissionId: scope.submissionId } : {}),
          ...(scope?.mrn ? { mrn: scope.mrn } : {}),
        }}
        onDecided={onDecided}
        currentSubmissionId={currentSubmissionId}
      />
    </>
  )
}
